export const getProductFromSessionStorage = () => {
  return window.sessionStorage.getItem('product')
}
export const setProductToSessionStorage = productName => {
  return window.sessionStorage.setItem('product', productName)
}
export const removeProductFromSessionStorage = () => {
  return window.sessionStorage.removeItem('product')
}
export const getUserInfoFromLocalStorage = () => {
  return window.localStorage.getItem('ecoCloudUserInfo')
}

export const setUserInfoToLocalStorage = userinfo => {
  return window.localStorage.setItem('ecoCloudUserInfo', userinfo)
}

export const removeUserInfoFromLocalStorage = () => {
  return window.localStorage.removeItem('ecoCloudUserInfo')
}



// WEBPACK FOOTER //
// ./src/utils/auth.js